import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import createMarkup from 'utils/createMarkup';
import config from 'apps/notifications/config';

export default class FlashMessage extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    level: PropTypes.oneOf(['success', 'error']),
    sticky: PropTypes.bool.isRequired,
    hideMessage: PropTypes.func.isRequired,
  };

  state = {
    hover: false,
  };

  componentDidMount() {
    const { id } = this.props;
    if (!this.props.sticky) {
      this.timer = setTimeout(() => {
        if (!this.state.hover) {
          this.props.hideMessage(id);
        }
        this.timer = null;
      }, config.notificationDuration);
    }
  }

  handleMouseEnter = () => {
    this.setState({ hover: true });
  };

  handleMouseLeave = () => {
    this.setState({ hover: false });
    if (!this.timer && !this.props.sticky) {
      this.props.hideMessage(this.props.id);
    }
  };

  handleClose = () => {
    const { id } = this.props;
    this.props.hideMessage(id);
  };

  renderMessage() {
    const { text } = this.props;

    return (
      <span dangerouslySetInnerHTML={createMarkup(text)} />
    );
  }

  render() {
    const { level } = this.props;
    const classes = ['ntf-flashMessages__message'];
    if (level) {
      classes.push(`ntf-flashMessages__message--${level}`);
    }

    return (
      <div
        className="ntf-flashMessages__messageWrapper"
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <div className={classNames(classes)}>
          {this.renderMessage()}
          <button
            aria-label="Close"
            className="ntf-flashMessages__close"
            onClick={this.handleClose}
          />
        </div>
      </div>
    );
  }
}
